import airportTimezones from '../../airportTimezones.json'
import moment from 'moment-timezone'
import _ from 'lodash';

// TODO // put all date functions in a separate file 6/16/2021
const pad = (num) => {
  return Number(num) < 10 ? '0' + num : num
}

export const formatFlightDate = (date) => {
  // NOTE // output: 17AUG, input: 2021-08-17
  let day = date.slice(8, 10)
  let month = date.slice(5, 7)
  let year = date.slice(0, 4)
  let monthsArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  month = monthsArr[Number(month) - 1]
  return `${day + month + year}`
}

// NOTE // returns false if ETD/ETA is before the original dep/arr
export const isETAfter = (ETime, original) => {
  let ETHour = ETime.slice(0, 2)
  let ETMinute = ETime.slice(3)
  let ogHour = typeof original === 'string' ? original.slice(0, 2) : original.getHours()
  let ogMinute = typeof original === 'string' ? original.slice(3) : original.getMinutes()
  if (ETHour < ogHour) {
    return false
  }
  else if (ETHour === ogHour) {
    return ETMinute >= ogMinute ? true : false
  }
  else {
    return true
  }
}

const formatTimelineDate = (date, hours, mins) => {
  let dateArr = date.split('-')
  dateArr[0] = Number(dateArr[0])
  dateArr[1] = Number(dateArr[1]) - 1
  dateArr[2] = Number(dateArr[2])
  return new Date(dateArr[0], dateArr[1], dateArr[2], Number(hours), Number(mins))
}

// NOTE // I hate javascript timezones
// NOTE // input date format: YYYY-MM-DD  returns a date object
export const formatDate = (date, flight, output) => {
  let ETD = flight.ETD ? (flight.ETD.length > 12 ? flight.ETD.slice(12) : flight.ETD) : ''
  let ETA = flight.ETA ? (flight.ETA.length > 12 ? flight.ETA.slice(12) : flight.ETA) : ''
  // NOTE // using isETAfter to check if an ETD/ETA is before the original dep/arr (because that'll break the timeline)
  let fltDeparture = ETD ? ETD : flight.Departure
  let fltArrival = ETA  ? ETA : flight.Arrival
  // NOTE // grab the airport timezones
  let depTz = airportTimezones[flight.Origin]
  let arrTz = airportTimezones[flight.Destination]
  // NOTE // set the timezone for the dep/arr
  let depMoment = moment.tz(date + ' ' + fltDeparture, depTz)
  let arrMoment = moment.tz(date + ' ' + fltArrival, arrTz)
  // NOTE // get the airport and user timezone-offsets
  let depOffset = depMoment._offset
  let arrOffset = arrMoment._offset
  let localOffset = new Date().getTimezoneOffset()
  // NOTE // get the difference between user and airport timezone-offsets
  let depDiff = (localOffset + depOffset)/60
  let arrDiff = (localOffset + arrOffset)/60
  let time
  let offsetDif
  // NOTE // set the output info depending on the output prop
  if (output.toUpperCase().includes('DEP')) {
    time = fltDeparture
    offsetDif = depDiff
  }
  else if(output.toUpperCase().includes('ARR')) {
    time = fltArrival
    offsetDif = arrDiff
  }
  // NOTE // get and set the date to return a date-object
  const hours = time.substring(0, 2);
  const min = time.substring(3);
  if (output.toUpperCase().includes('LOCAL')) {
    // FIXME // lines 74-81 changes
    let adjustedHours = hours - offsetDif
    let newDate = formatTimelineDate(date, adjustedHours, min)
    return newDate
  }
  else {
    let newDate = formatTimelineDate(date, hours, min)
    return newDate
  }
}

export const formatPaxName = (nameArr) => {
  for (let i = 0; i < nameArr.length; i++) {
    let name = nameArr[i];
    name = name.toLowerCase()
    // NOTE // new name array? Idk why I called this nna
    let nna = name.split('').filter(n => n)
    nna[0] = nna[0].toUpperCase()
    nameArr[i] = nna.join('')
  }
  return nameArr.join(' ') + ' '
}

// NOTE // takes in a departure and arrival time (format 'HH:MM') and returns either a string or number based on isText
export const getFlightDuration = (dep, arr, isText) => {
  let depHrs = Number(dep.substring(0, 2))
  let arrHrs = Number(arr.substring(0, 2))
  let depMins = Number(dep.substring(3, 5))
  let arrMins = Number(arr.substring(3, 5))
  let minDif = arrMins - depMins
  let hrDif
  // NOTE // if the minute difference is negative
  if (minDif < 0) {
    // NOTE // take away an hour
    hrDif = arrHrs - depHrs - 1
    // NOTE // subtract the absolute value of minDif from 60 (i.e. dep: 11:15 arr: 12:05 => hrDif is 1 minDif is -10 => 60 - 10 = 50)
    minDif = 60 - Math.abs(minDif)
  }
  else {
    hrDif = arrHrs - depHrs
  }

  if (isText) {
    return `${hrDif > 0 ? 'hrs:' + pad(hrDif) + ' ' : ''}mins:${pad(minDif)}`
  }
  // NOTE // if isText is false or not there, return a number representing the duration in hours
  else {
    return hrDif + (minDif/60)
  }
}

export const getFlightStatus = (flight, isStatus) => {
  let overlaps = []
  let curFlight
  // NOTE // inside the chart the item is being passed with some new properties to check for overlaps
  if (flight.item) {
    overlaps = flight.overlaps
    curFlight = flight.item
  }
  else {
    curFlight = flight
  }
  
  let ETD = curFlight.ETD
  let ETA = curFlight.ETA
  let dep = curFlight.originalDeparture ? curFlight.originalDeparture : curFlight.Departure

  // NOTE // priority is cancelled, overlapping, delayed, active
  if (curFlight.NOPAX === "1") {
    return !isStatus ? 'rgb(234, 152, 154)' : 'Cancelled'
  }
  // NOTE // if the flight has an estimated time of departure (ETD) and an estimated time of arrival (ETA), it is probably delayed
  else if (ETD && ETA) {
    if (overlaps.length > 0) {
      return !isStatus ? 'orchid' : 'Active'
    }
    let ETDTime = new Date(ETD).getTime()
    // NOTE // gets the time for the departure using the day from ETD (estimated time of departure)
    let depTime = new Date((ETD.slice(0, 11) + ' ' + dep)).getTime()
    // NOTE // if the estimated time of departure is after departure make it orange to indicate it's delayed
    if (ETDTime > depTime) {
      // NOTE // delayed is still considered active as far as filtering is concerned
      return !isStatus ? 'orange' : 'Active'
    } else if(depTime > ETDTime) {
      return !isStatus ? 'yellow' : 'Active'
    }
    // NOTE // if there is an ETA/ETD that are the same as the original arrival/dep time, it's active
    return !isStatus ? '#9fc5e9' : 'Active'
  }
  else if (overlaps.length > 0) {
    return !isStatus ? 'orchid' : 'Active'
  }
  else {
    return !isStatus ? '#9fc5e9' : 'Active'
  }
}

export const isFlightOpen = (flight) => {
  if (flight && !!flight.DCSFltStatus) {
    // FIXME // getting occasional error for betterRow.status
    // NOTE // 10 is closed, 5 or '' is open
    let dcsStatus = flight.DCSFltStatus
    if (dcsStatus === '10') {
      return false
    }
    else {
      return true
    }
  }
  return true
}

export const formatPax = (paxArr) => {
  let paxStr = ' '
  if (Array.isArray(paxArr) && paxArr.length) {
    for (let i = 0; i < paxArr.length; i++) {
      const pax = paxArr[i];
      // NOTE // gets the first and last name then formats it (i.e. KORBIN WILLIAMS => Korbin Williams)
      let name = formatPaxName(pax.trim().split(' ').slice(0, 2))
      // NOTE // 
      let paxInfo = pax.split(' ').slice(2).join(' ')
      paxStr += `${name + paxInfo + (paxArr[i+1] ? '<br/>' : '')}`
    }
  }
  return paxStr
}

const delayedDisplay = (flight) => {
  let output = ``
  if (flight.originalDeparture && flight.airportDepTime && flight.originalDeparture !== flight.airportDepTime) {
    output = `<div style="background-color:#7baaf7;"><b>Original</b>: ${flight.originalDeparture}, <b>Now</b>: ${flight.airportDepTime}</div>`
  }

  return output
}

export const formatFlightHtml = (flight, flightDate) => {
  let passengers = flight.PaxList ? flight.PaxList.split(';') : []

  // TODO // look into adding classes to html in Timeline
  let flightHmtl = 
  `<div style="width:250px; height:${125 + (passengers && passengers.length ? (passengers.length * 18) : 0)}px; margin-bottom:5px">
  <div style="background-color:#7baaf7; padding-top:5px; border-bottom:2px solid black; margin-bottom:4px">
    <b>${flight.FlightNumber}</b>
  </div>
  ${delayedDisplay(flight)}
  <b>Flight Dur</b>: ${getFlightDuration(flight.Departure, flight.Arrival, true)} <br/>
  ${formatPax(passengers)}
  </div>`

  return flightHmtl
}